import { getTokenFromModeLink } from '@mode/shared/util-halogen';
import { NotebookVisualizationResource, SessionResource } from '@mode/legacy/data-access-model-js';
import { NormalizedNotebookCell, NormalizedNotebookCellRunResult } from '@mode/legacy/types-app-state';
import { NotebookTypes } from '@mode/notebooks/contract';

export namespace NotebookHelpers {
  export function renderCellEmbed(
    reportRunToken: string,
    layoutCell: NotebookVisualizationResource,
    cellResults: NormalizedNotebookCellRunResult[]
  ) {
    return {
      title: layoutCell.title,
      state: cellResults && cellResults.length ? 'succeeded' : 'empty',
      vizLink: layoutCell.links('report_pythonviz_web').href,
      vizReportRunLink: cellVizLink(layoutCell, reportRunToken),
      results: renderVizContentResult(cellResults),
    };
  }

  export function cellVizLink(layoutCell: NotebookVisualizationResource, reportRunToken: string) {
    return layoutCell.hasLink('report_run_pythonviz_web')
      ? layoutCell.links('report_run_pythonviz_web').$expand({ token: reportRunToken }, { excludeSSLPort: true })
      : '';
  }

  export function renderVizContentResult(results: NormalizedNotebookCellRunResult[]) {
    return results.map((res) => ({
      content: res.content,
      type: res.content_type,
      result_type: res.result_type,
    }));
  }

  export function isSessionEmpty(session: SessionResource) {
    return !session.hasLink('last_loaded_run');
  }

  export function isSessionReportRunOutdated(session: SessionResource, runToken: string) {
    return !session.hasLink('last_loaded_run') || getTokenFromModeLink(session.links('last_loaded_run')) !== runToken;
  }

  /*
   * If memory > 90%, return a message to the user.
   * Remove the message when memory < 50%.
   * Keep showing the message if memory is between 50% and 90%.
   * @param metrics {NotebookTypes.Metrics}
   */
  export function warnFromMetrics(metrics: NotebookTypes.Metrics, previousState = false): boolean {
    if (metrics) {
      if (metrics.memory_usage >= metrics.max_memory) {
        return true;
      } else return metrics.memory_usage >= metrics.min_memory && previousState;
    }

    return false;
  }
}
